import $ from 'jquery';
window.$ = $;
window.jQuery = $;

import './bootstrap';
import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;

import('./plugins/inputSpinner');

import './plugins';
import './main';

import './components';
import './loading';
import './ReCaptcha';
import './masks';

// Admin
if (document.documentElement.matches('[data-page="admin"]')) {
    import('./admin');
}
